import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02f958dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "This activation link has already been used or expired.", -1))
const _hoisted_2 = { class: "m-top-20" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Please ")
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" to resend. ")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "m-bottom-25" }, "Confirmation on your email", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Almost there.")
], -1))
const _hoisted_9 = { class: "m-bottom-10" }
const _hoisted_10 = { class: "resend m-bottom-5" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Not in inbox or spam folder? ")
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "back", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.confirmAccount)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.errorConfirmAccount)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_1,
              _createElementVNode("p", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("button", {
                  class: "btn-link",
                  disabled: _ctx.time > 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resend(true)))
                }, " click here ", 8, _hoisted_4),
                _hoisted_5
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("h1", _hoisted_6, "Please wait"))
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, "We sent a confirmation e-mail to " + _toDisplayString(_ctx.data) + ". Please open it and follow the link", 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", null, [
            _hoisted_11,
            _createElementVNode("button", {
              class: "btn-link",
              disabled: _ctx.time > 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resend && _ctx.resend(...args)))
            }, "Resend", 8, _hoisted_12),
            (_ctx.time > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" (" + _toDisplayString(_ctx.time) + ") ", 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("button", {
          class: "btn-link",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _hoisted_14)
      ], 64))
}